export function trackUiEvent (name, properties = {}) {
  window.dispatchEvent(new CustomEvent('connector-hub:analytics', {
    detail: { name, properties, occurred_at: new Date().toISOString() }
  }))
}
